import Index from '@/pages/password-policy/Index';
import Modify from '@/pages/password-policy/Modify';

export default {
  path: 'password-policy',
  component: Index,
  children: [
    {
      path: 'index',
      component: Modify
    }
  ]
}